import { Modal, ButtonGroup, Button } from '@nike/eds';
import { useRevalidator } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from 'constants/index';
import RankingClient from '../../clientAPI/ranking';

export default function RankingRuleTriggerModal({
  isOpen,
  ruleData,
  onClose,
  successCallback,
  failureCallback,
}: {
  isOpen: boolean;
  ruleData: RankingRule;
  onClose: VoidFunction;
  successCallback: VoidFunction;
  failureCallback: VoidFunction;
}) {
  const revalidator = useRevalidator();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (data: RankingRule): Promise<RankingRule> => {
      if (data._id) {
        return RankingClient.toggleRankingRuleStatus(
          data._id,
          ruleData.status as string,
        );
      } else {
        throw new Error('Ranking rule ID is required');
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.RANKING_RULE_LIST],
      });
      successCallback();
    },
    onError: (err: keyable) => {
      err.status === 401 && revalidator.revalidate();
      failureCallback();
    },
  });
  const onConfirm = () => {
    mutation.mutate(ruleData);
    onClose();
  };
  const operationMsg = ruleData.status === 'ACTIVE' ? 'deactivate' : 'activate';
  return (
    <Modal
      onDismiss={onClose}
      isOpen={isOpen}
      headerSlot='Confirm to change rule status'
    >
      <div>
        Are you sure to{' '}
        <span className='tw-uppercase tw-font-bold'>{operationMsg}</span> rule{' '}
        <span className='tw-italic'>{ruleData.name}</span>
      </div>
      <ButtonGroup className='tw-justify-end'>
        <Button
          onClick={onConfirm}
          size='small'
          variant='secondary'
          className='eds-background--green-60 eds-color--white eds-border--green-60'
        >
          Confirm
        </Button>
        <Button onClick={onClose} size='small' variant='secondary'>
          Cancel
        </Button>
      </ButtonGroup>
    </Modal>
  );
}
